import React, { useState } from "react";
import { Accordion } from "@origin-digital/style-guide";
import styled from "styled-components";

export interface ICallbackEvent {
  isOpen: boolean;
}

export interface IAccordion {
  label: string;
  href: string;
  child?: React.ReactNode;
}

export interface IAccordionGroupProps {
  accordions: IAccordion[];
  onAccordionOpen?: (
    event: ICallbackEvent,
    accordian: IAccordion
  ) => Promise<void> | void;
  open?: Record<string, boolean | undefined>;
}

const HiddenLinkContainer = styled.div`
  max-height: 0px;
  overflow: hidden;
`;

export const AccordionGroup = ({
  accordions,
  onAccordionOpen,
  //@ts-ignore
  open = {},
}: IAccordionGroupProps) => {
  const [openState, setOpenState] = useState<
    Record<string, boolean | undefined>
  >(open);

  const onToggle = (
    accordion: IAccordion
  ): ((event: ICallbackEvent) => void) => {
    return (event) => {
      setOpenState({ [accordion.label]: event.isOpen ? true : undefined });
      if (onAccordionOpen) {
        onAccordionOpen(event, accordion);
      }
    };
  };

  return (
    <>
      {accordions.map((acc, index) => {
        return (
          <>
            <Accordion
              data-id={`accordion-group-${index}`}
              label={acc.label}
              onToggle={onToggle(acc)}
              open={openState[acc.label] || false}
              key={acc.label}
            >
              {acc.child && openState[acc.label] ? acc.child : <></>}
            </Accordion>
            <HiddenLinkContainer>
              <a href={acc.href}>{`Show all articles for ${acc.label}`}</a>
            </HiddenLinkContainer>
          </>
        );
      })}
    </>
  );
};
